import { isVisitorInChina } from './_utils';
const queued = [];
let loading = false;

export const ytReady = func => {
	if (!isVisitorInChina() && !loading) {
		loading = true;
		ytInit();
		var tag = document.createElement('script');
		tag.src = 'https://www.youtube.com/iframe_api';
		var firstScriptTag = document.getElementsByTagName('script')[0];
		firstScriptTag.parentNode.insertBefore(tag, firstScriptTag);
	}
	if (window.YT) {
		window.YT.ready(func);
	} else {
		queued.push(func);
	}
};

export const ytInit = () => {
	window.onYouTubeIframeAPIReady = () => {
		queued.forEach(func => {
			window.YT.ready(func);
		});
	};
};
